import { toRefs } from '@vueuse/core'
import type { UseAuthentication } from '~/types/rental-api-aliases'
import type { Nullable } from '~/types'
import { PERMISSIONS } from '~/constants'

/**
 * Wraps the getUser util function with a reactive data source.
 *
 * Using toRefs also keeps reactivity after destructuring.
 */
export default function useUser() {
  // Casting the type until sidebase supports providing a type
  // https://github.com/sidebase/nuxt-auth/issues/1031
  const { data } = useAuth() as { data: Ref<Nullable<UseAuthentication>> }
  const permissions = usePermissions()

  const userExists = computed(() => Boolean(data.value))
  const userIsAdmin = computed(() => permissions.value?.includes(PERMISSIONS.administrator))
  const userCanManageCampgrounds = computed(() => userIsAdmin.value || permissions.value?.includes(PERMISSIONS.campgroundManager))

  // Compute all the user details.
  const userDetails = computed(() => getUser(data?.value))

  return {
    user: data,
    userExists,
    userIsAdmin,
    userCanManageCampgrounds,
    ...toRefs(userDetails),
  }
}
